import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import AlphaLogo from "../../img/logo.png";
import renderLangString from "../../languageStrings";
import GLOBALS from "../../globals";
import { axiosWithAuth as axios } from "../../axiosSetup";

// REDUX
import { connect } from "react-redux";
import { setLanguage } from "../../actions/appActions";
import ACTIONS from "../../actions/types";

// COMPONENTS
import NewButton from "../buttons/NewButton";
import Layout from "../layout/Layout";

// GLOBALS
import AA_GLOBAL from "../../globals/globals";

export class FooterMain extends Component {
  state = {
    currentLocale: this.props.currentApp && this.props.currentApp.chosen_locale,
    locales: this.props.currentApp && this.props.currentApp.locales,
  };

  componentDidMount() {}

  // changeLanguage = async newLocale => {
  //   await axios.get("/api/lang", { params: { l: newLocale.split("-")[0] } });

  //   this.setState({ currentLocale: newLocale }, () => {
  //     AA_GLOBAL.cookies.set("lang", newLocale, { path: "/" });
  //     window.location.reload();
  //     // this.props.history.push(window.location.pathname);
  //     // this.props.setLanguage(newLocale);
  //   });
  // };

  openCookiePolicy = () => {
    GLOBALS.reduxStore.dispatch({ type: ACTIONS.SHOW_COOKIE_PROMPTER });
  };

  render() {
    const { currentLocale, locales } = this.state;

    return (
      <footer className="footer">
        <div className="footer__right">
          <a
            href="https://www.alpha-awards.com/"
            className="footer__right-link"
            data-test="AA_link"
            target="_black"
          >
            <span>
              <FormattedMessage id="powerdBy" />
            </span>
            <img
              src={AlphaLogo}
              alt="alpha awards"
              className="footer__right-logo"
              data-test="AA_logo"
            />
          </a>
        </div>
        <div className="footer__left">
          {/* HIDE THIS FOR PRESENTATION */}
          <Layout flex>
            {/* TODO: not ready yet
            <div className="u-hide">
              <a href="#empty" className="footer__left-a" data-test="FAQ"><FormattedMessage id="faq"/></a> -
              <a href="#empty" className="footer__left-a" data-test="Imprint"><FormattedMessage id="imprint"/></a>
            </div>
            */}
            <div className="footer__lang">
              {locales &&
                locales
                  .map(locale => ({
                    locale,
                    label: locale.split("-")[0].toUpperCase(),
                    isChosen: currentLocale === locale,
                  }))
                  .map((item, i) => (
                    <span key={item.locale}>
                      {item.isChosen ? (
                        <span style={{ cursor: "default" }} className="footer__lang-btnActive">
                          {item.label}
                        </span>
                      ) : (
                        // <span
                        //   tabIndex="0"
                        //   onClick={() => this.changeLanguage(item.locale)}
                        //   onKeyDown={e => e.key === "Enter" && this.changeLanguage(item.locale)}
                        // >
                        //   {item.label}
                        // </span>
                        <a href={`/lang?l=${item.label.toLowerCase()}`}>{item.label}</a>
                      )}
                      {i + 1 !== locales.length && " | "}
                    </span>
                  ))}
            </div>
            <NewButton
              value={renderLangString({ id: "$_e8" })}
              style={{ marginLeft: "1rem" }}
              colStyle="noColor"
              btnStyle="noStyles"
              onKeyPress={this.openCookiePolicy}
              onClick={this.openCookiePolicy}
            />
          </Layout>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = state => ({
  currentApp: state.app.info.apps[state.app.info.default_app],
});

export default connect(mapStateToProps, { setLanguage })(FooterMain);
